export const FooterSection = () => `
  <footer class="bg-white py-12">
    <div class="container mx-auto px-6">
      <div class="text-center">
        <a href="https://farskapet.no" class="text-secondary hover:text-accent transition-colors">
          Besøk Farskapet.no
        </a>
        <p class="text-sm text-gray-600 mt-4">
          © ${new Date().getFullYear()} Farskapet AS. Alle rettigheter reservert.
        </p>
      </div>
    </div>
  </footer>
`;